import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Environment } from '../models/environment.model';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private http = inject(HttpClient);
  private environment: Environment | null = null;

  async loadEnvironment(): Promise<Environment> {
    try {
      // Load environment.json at runtime
      this.environment = await firstValueFrom(
        this.http.get<Environment>('/config/environment.json')
      );
      console.log('Environment loaded:', this.environment.environmentName);
      return this.environment;
    } catch (error) {
      console.error('Failed to load environment configuration:', error);
      // Fallback to default local configuration
      this.environment = {
        production: false,
        environmentName: 'local',
        api: {
          baseUrl: 'https://localhost:7075/api',
          timeout: 30000
        },
        logging: {
          level: 'debug',
          enableConsoleLogging: true
        },
        applicationInsights: {
          connectionString: ''
        }
      };
      return this.environment;
    }
  }

  getEnvironment(): Environment {
    if (!this.environment) {
      throw new Error('Environment not loaded. Ensure APP_INITIALIZER has completed.');
    }
    return this.environment;
  }

  get production(): boolean {
    return this.getEnvironment().production;
  }

  get environmentName(): string {
    return this.getEnvironment().environmentName;
  }

  get apiBaseUrl(): string {
    return this.getEnvironment().api.baseUrl;
  }

  get apiTimeout(): number {
    return this.getEnvironment().api.timeout;
  }

  get loggingLevel(): string {
    return this.getEnvironment().logging.level;
  }

  get enableConsoleLogging(): boolean {
    return this.getEnvironment().logging.enableConsoleLogging;
  }
}

